import { action, observable } from 'mobx';
import { api } from '../config';

// Helpers
import { formatQuery } from '../helpers';

// AppStore (used for loading, error throwing, etc.)
import AppStore from './AppStore';

// UserStore (used to access user data)
import UserStore from './UserStore';

let obx = observable({
  reportData: null,
  appendix: [],

  /**
   * getReportData - Gets the data for a student’s PLG report
   * @param {object} query
   * @param {function} callback
   */
  getReportData: action((query, callback) => {
    AppStore.startLoading('getReportData');

    const url = `/installs/${UserStore.installSid}/reports/dynamicReport${formatQuery(
      query
    )}`;

    api.get(url)
      .then(response => {
        const reportSid = response.data[0] ? 
          response.data[0].reportSid
          : null;

        // Add hardcoded appendix
        response.data.push({
          title: { en: 'Appendix' },
          sections: [],
          reportSid
        });

        obx.reportData = response.data;

        /**
         * Build the Appendix content by getting all 'resource-links'
         */

        function filterPages(obj) {
          // Return only pages with sections
          return obj['sections'].length > 0;
        }

        function filterSections(obj) {
          // Return only sections with content
          return obj['content'].length > 0;
        }

        function filterContent(obj) {
          // Return only Resource Link content
          return obj['type'] === 'resource-links';
        }

        let appendix = obx.reportData.map(page => {
          return {
            ...page,
            sections: page.sections.map(section => {
              return {
                ...section,
                content: section.content.filter(item => filterContent(item))
              }
            }).filter(section => filterSections(section))
          }
        });

        obx.appendix = appendix.filter(page => filterPages(page));

        if (callback) {
          callback(response.data);
        }

        AppStore.finishLoading('getReportData');
      })
      .catch(error => {
        AppStore.throwError(error);
      });
  })
});

export default obx;
